export default "__VITE_ASSET__f1bf3a0b__"